import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";
import { getSessionRequest } from "../api/public/session";

// 解决vue3.0跳转路由与当前路由相等的bug
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: () => import("../views/Home.vue")
    },
    {
        path: "/test",
        name: "Test",
        component: () => import("../views/Test.vue")
    },
    {
        path: "/register",
        name: "Register",
        meta: { title: "用户注册" },
        component: () => import("../views/Register.vue")
    },
    {
        path: "/virtualExp",
        name: "VirtualExp",
        meta: { title: "虚拟实验" },
        component: () => import("../views/VirtualExp.vue")
    },
    {
        path: "/expCenter",
        name: "ExpCenter",
        meta: { title: "实验中心" },
        component: () => import("../views/ExpCenter.vue")
    },
    {
        path: "/declareExp/:id",
        name: "DeclareExp",
        meta: { title: "申报项目" },
        component: () => import("../views/DeclareExp.vue")
    },
    {
        path: "/declareExp",
        name: "DeclareExp",
        meta: { title: "申报项目" },
        component: () => import("../views/DeclareExp.vue")
    },
    {
        path: "/expInfo",
        name: "ExpInfo",
        meta: { title: "实验信息" },
        component: () => import("../views/ExpInfo.vue")
    },
    {
        path: "/expData",
        name: "ExpData",
        meta: { title: "实验数据" },
        component: () => import("../views/ExpData")
    },
    {
        path: "/CaseView",
        name: "CaseView",
        meta: { title: "案例浏览" },
        component: () => import("../views/CaseView.vue")
    },
    {
        path: "/manager",
        redirect: "/manager/index",
        name: "Manager",
        meta: { title: "实验信息", requiresAuth: true, requiresAdmin: true },
        component: () => import("../views/Manager.vue"),
        children: [
            {
                path: "index",
                name: "index",
                meta: { title: "" ,requiresAuth: true, requiresAdmin: true },
                component: () => import("../views/manager/Index.vue")
            },
            {
                path: "role",
                name: "role",
                meta: { title: "" ,requiresAuth: true, requiresAdmin: true},
                component: () => import("../views/manager/Role.vue")
            },
            {
                path: "permissions",
                name: "Permissions",
                meta: { title: "" ,requiresAuth: true, requiresAdmin: true},
                component: () => import("../views/manager/Permissions.vue")
            },
            {
                path: "admin",
                name: "Admin",
                meta: { title: "" ,requiresAuth: true, requiresAdmin: true},
                component: () => import("../views/manager/Admin.vue")
            },
            {
                path: "expData",
                name: "ExpData",
                meta: { title: "实验数据" ,requiresAuth: true, requiresAdmin: true},
                component: () => import("../views/manager/ExpData")
            },
            {
                path: "webNewsList",
                name: "WebNewsList", 
                meta: { title: "新闻管理" ,requiresAuth: true, requiresAdmin: true},
                component: () => import("../views/manager/WebNewsList")
            }, 
            {
                path: "webNewsUpdate",
                name: "WebNewsUpdate", 
                meta: { title: "新闻编辑",requiresAuth: true, requiresAdmin: true },
                component: () => import("../views/manager/WebNewsUpdate")
            },
            
            {
                path: "webNoticeList",
                name: "WebNoticeList",
                meta: { title: "公告管理" ,requiresAuth: true, requiresAdmin: true},
                component: () => import("../views/manager/WebNoticeList")
            },
            
            {
                path: "webNoticeUpdate",
                name: "WebNoticeUpdate",
                meta: { title: "公告编辑" ,requiresAuth: true, requiresAdmin: true},
                component: () => import("../views/manager/WebNoticeUpdate")
            },
            
            {
                path: "/manager/CaseList",
                name: "CaseList",
                meta: { title: "案例管理" ,requiresAuth: true, requiresAdmin: true},
                component: () => import("../views/manager/CaseList"),

            }, 
            {
                path: "/manager/CaseList/CaseEditor",
                name: "CaseEditor",
                meta: { title: "案例编辑" ,requiresAuth: true, requiresAdmin: true},
                component: () => import("../views/manager/CaseEditor")
                }
            
          


            
        ]
    },
    {
        path: "/caselibrary",
        name: "CaseLibrary",
        meta: { title: "真实项目案例库" },
        component: () => import("../views/CaseLibrary.vue")
     },
    // {
    //     path: "/labManager",
    //     name: "LabManager",
    //     meta: { title: "实验室管理平台" },
    //     component: () => import("../views/LabManager.vue")
    // },
    {
        path: "/base",
        name: "Base",
        meta: { title: "实践教育基地管理" },
        component: () => import("../views/Base.vue")
    },
    {
        path: "/news",
        name: "News",
        meta: { title: "综合新闻" },
        component: () => import("../views/News.vue")
    },
    {
        path: "/notice",
        name: "Notice",
        meta: { title: "虚拟实验平台公告" },
        component: () => import("../views/Notice.vue")
    },
    {
        path: "/labNews",
        name: "LabNews",
        meta: { title: "综合新闻" },
        component: () => import("../views/LabNews.vue")
    },
    {
        path: "/labNotice",
        name: "LabNotice",
        meta: { title: "通知公告" },
        component: () => import("../views/LabNotice.vue")
    },
    {
        path: "/labPage",
        name: "LabPage",
        meta: { title: null },
        component: () => import("../views/LabPage.vue")
    },
    {
        path: "*",
        name: "Error",
        meta: { title: "找不到页面" },
        component: () => import("../views/Error.vue")
    }
];

const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    // 修改title
    document.title = to.meta.title ? to.meta.title : process.env.VUE_APP_TITLE;
    // 获取路由列表
    const pathList = to.path.split("/");
    // 更新路由列表，用来刷新面包屑
    store.commit("updateRouterList", pathList);

    // 路由守卫获取用户信息

    getSessionRequest().then(res => {
        console.log(res);
            if ("" === res.userinfo) res.userinfo = {};

            store.state.userInfo=res.userinfo;

           // console.log("获取用户信息"+JSON.stringify(store.state.userInfo));

   
            // 在获取用户信息后，进行权限校验
            if (to.meta.requiresAuth && !isAuthenticated()) {
         
                next("/");
           } else if (to.meta.requiresAdmin && !isAdmin()){
             next("/");
                    
           }
           else{
               next();
           }
           


        });
 

  
 
});
function isAuthenticated() {
   return JSON.stringify(store.state.userInfo)!="{}";
}

function isAdmin() {
    let level = [];
    var levelstr=store.state.userInfo.islogin+'';
    level = levelstr.split("");

   if(level[0]<=1){
        return false;
   }

   return true;
}
export default router;
